module.exports = __webpack_public_path__ + "static/media/faq-bubbles.1c9b99f9.svg";